import { Action } from '@ngrx/store';

export enum EPendingChangesActions {
  SetOriginalUserGroup = '[Original user group] set the selected user group before edit',
  RequestPendingChanges = '[Request pending changes] validate if hava pending changes',
  validateChanges = '[Validate pending changes] status about if has pending changes',
  pendingChangesAction = '[Pending changes action] The resolution action about pending changes',
  ResetProperties = '[Reset Pending Properties] Reset Pending Changes properties',
  RequestPendingChangesDone = '[Request pending changes] Request pending changes done',
  ResetPendingChangesState = '[Pending changes action] Reset pending changes state'
}

export class SetOriginalUserGroup implements Action {
  public readonly type = EPendingChangesActions.SetOriginalUserGroup;
  constructor(public payload: IUserGroup) { }
}

export class RequestPendingChanges implements Action {
  public readonly type = EPendingChangesActions.RequestPendingChanges;
  constructor(public payload?: Guid) { }
}

export class validateChanges implements Action {
  public readonly type = EPendingChangesActions.validateChanges;
  constructor(public payload: { userGroupModified: IUserGroup, nextGuid?: Guid }) { }
}

export class pendingChangesAction implements Action {
  public readonly type = EPendingChangesActions.pendingChangesAction;
  constructor(public payload: number) { }
}


export class ResetProperties implements Action {
  public readonly type = EPendingChangesActions.ResetProperties;
}

export class RequestPendingChangesDone implements Action {
  public readonly type = EPendingChangesActions.RequestPendingChangesDone;
  constructor() { }
}

export class ResetPendingChangesState implements Action {
  public readonly type = EPendingChangesActions.ResetPendingChangesState;
  constructor() { }
}

export type FilterUserActions =
  | SetOriginalUserGroup
  | RequestPendingChanges
  | validateChanges
  | pendingChangesAction
  | ResetProperties
  | RequestPendingChangesDone
  | ResetPendingChangesState;
